module.exports = __webpack_public_path__ + "static/20141025_110807-78799f2378f50707985aee24fb5f2b4c.jpg";